import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import VenuePromotionRequestListLayer from "../../components/VenuePromotionRequest/VenuePromotionRequestListLayer";

const VenuePromotionRequestList = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Venue Promotion Request" />
      <VenuePromotionRequestListLayer requestType="host" />
    </MasterLayout>
  );
};

export default VenuePromotionRequestList;
